







import {Component, Vue, Prop} from "vue-property-decorator";
import Attribute from "@/api/Product/Attribute";
import Product from "@/api/Product";
import CompareTableAttributeValues from "@/components/Compare/CompareTable/CompareTableAttributeValues.vue";
@Component({
  components: {CompareTableAttributeValues}
})
export default class CompareTableAttribute extends Vue {
  @Prop() private attribute!: Attribute;
  @Prop() private products!: Product[];
  @Prop() private groupIndex!: number;
  @Prop() private attributeIndex!: number;
}
